import React, { useState, useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import guideImage from '../../assets/guide/1-1.PNG';
import homeImage from '../../assets/guide/2-1.PNG';
import dogopangImage1 from '../../assets/guide/3-1.PNG';
import dogopangImage2 from '../../assets/guide/3-2.PNG';
import videoGuide1 from '../../assets/guide/4-1.PNG';
import videoGuide2 from '../../assets/guide/4-2.PNG';
import videoGuide3 from '../../assets/guide/4-3.PNG';
import videoGuide4 from '../../assets/guide/4-4.PNG';
import videoGuide5 from '../../assets/guide/4-5.PNG';
import videoGuide6 from '../../assets/guide/4-6.PNG';
import videoGuide7 from '../../assets/guide/4-7.PNG';
import videoGuide8 from '../../assets/guide/4-8.PNG';
import videoGuide9 from '../../assets/guide/4-9.PNG';
import problemGuide1 from '../../assets/guide/5-1.PNG';
import problemGuide2 from '../../assets/guide/5-2.PNG';
import problemGuide3 from '../../assets/guide/5-3.PNG';
import problemGuide4 from '../../assets/guide/5-4.PNG';
import problemGuide5 from '../../assets/guide/5-5.PNG';
import problemGuide6 from '../../assets/guide/5-6.PNG';
import problemGuide7 from '../../assets/guide/5-7.PNG';
import problemGuide8 from '../../assets/guide/5-8.PNG';
import problemGuide9 from '../../assets/guide/5-9.PNG';
import problemGuide10 from '../../assets/guide/5-10.PNG';
import problemGuide11 from '../../assets/guide/5-11.PNG';
import dogopangPlusGuide1 from '../../assets/guide/6-1.PNG';
import dogopangPlusGuide2 from '../../assets/guide/6-2.PNG';
import reportGuide1 from '../../assets/guide/7-1.PNG';
import classGuide1 from '../../assets/guide/8-1.jpg';
import classGuide2 from '../../assets/guide/8-2.jpg';
import classGuide3 from '../../assets/guide/8-3.jpg';
import classGuide4 from '../../assets/guide/8-4.png';
import classGuide5 from '../../assets/guide/8-5.png';
import classGuide6 from '../../assets/guide/8-6.jpeg';

const guides = [
  {
    id: 8,
    title: '학습권 등록 안내',
    date: '2025-06-20',
    content: [
      {
        text: '▶ 학습권 등록 안내\n- 학습권 등록은 관리자모드에서 가능합니다.\n(홈페이지 오른쪽 아래 관리자모드)\n\n',
      },
      {
        text: '1️⃣ 관리자모드 로그인'
      },
      {
        images: [classGuide1]
      },
      {
        text: '\n2️⃣ 맨 위 메뉴 초기화면 클릭'
      },
      {
        images: [classGuide2]
      },
      {
        text: '\n3️⃣ 왼쪽 아래 두고팡 정식가입'
      },
      {
        images: [classGuide3]
      },
      {
        text: '\n4️⃣ 학습권 선택'
      },
      {
        images: [classGuide4]
      },
      {
        text: '\n5️⃣ 결제하기'
      },
      {
        images: [classGuide5]
      },
      {
        text: '\n👉 학습모드 이용 중, 오른쪽 위 <학습권 등록> 클릭하여 관리자모드로 바로 이동 가능합니다.'
      },
      {
        images: [classGuide6]
      },
    ]
  },
  {
    id: 7,
    title: '학습레포트 이용 안내',
    date: '2025-04-14',
    content: [
      {
        text: '홈화면 빠른메뉴 탭에서 학습레포트를 클릭하면 이용할수 있는 기능입니다.\n레포트 조회, 레포트 분석의 기능이 있습니다.\n\n1. 레포트 조회에서는 학습한 컨텐츠에 대해서 확인할 수 있고, 각 컨텐츠를 클릭하면 상세 레포트를 조회할 수 있습니다.\n2. 레포트 분석에서는 학습한 컨텐츠에 대해서 종합분석을 확인할 수 있습니다.',
        images: [reportGuide1]
      }
    ]
  },
  {
    id: 6,
    title: '두고팡 플러스 컨텐츠 안내',
    date: '2025-04-14',
    content: [
      {
        text: '홈화면 학습컨텐츠 탭에서 두고팡플러스를 클릭하면 이용할수 있는 컨텐츠입니다.\n교재별 학습실, 문제은행, 만든 교재의 컨텐츠가 있습니다.',
        images: [dogopangPlusGuide1]
      },
      {
        text: '1. 교재별 학습실에서는 바둑교재 전문출판사 두드림에듀의 문제 컨텐츠를 교재별로 학습할 수 있습니다.\n2. 문제은행에서는 단계별 챌린지에 도전하고 나의 기력을 측정하는 문제컨텐츠를 학습 할 수 있습니다.\n3. 만든 교재에서는 학원 또는 선생님 만의 특별한 커리큘럼을 컨텐츠로 만들어 학습할 수 있습니다.\n(*만든교재 컨텐츠는 전체 공개되는 컨텐츠가 있고, 학원생 또는 수강생을 대상으로 공개가 제한된 컨텐츠가 있습니다.)',
        images: [dogopangPlusGuide2]
      }
    ]
  },
  {
    id: 5,
    title: '문제풀이 이용 안내',
    date: '2025-04-14',
    content: [
      {
        text: '두드림 바둑에서 각 단계를 클릭 후, 오른쪽 버튼 중 연습문제를 클릭하여 이용할 수 있습니다.\n(*심화문제도 이용방법은 같습니다)',
        images: [problemGuide1, problemGuide2]
      },
      {
        text: '▶ 학습 시작\n처음 학습시, 바로 문제를 풀이할 수 있는 화면으로 이동합니다.\n문제는 유형에 따라 바둑판에 바둑알을 클릭 또는 정답보기 중 선택하는 방법으로 풀이할 수 있습니다.',
        images: [problemGuide3]
      },
      {
        text: '▶ 학습중\n1. 문제풀이 학습을 시작하면, 화면 가운데에서 상단 질의와 중앙 문제 이미지를 확인후 문제풀이를 할 수 있습니다.\n2. 왼쪽에 표시된 숫자에서 현재 진행중인 문제 번호와 함께 정답, 오답을 확인할 수 있습니다.\n3. 오른쪽, 왼쪽 양 옆의 네비게이션을 통해 문제 이동이 가능합니다.\n4. 상단 왼쪽에는 현재 진행중인 목차가 표시되고, 오른쪽에는 총 문제 수가 표시됩니다.',
        images: [problemGuide4]
      },
      {
        text: '학습 중간에 문제풀이를 종료하려는 경우, 오른쪽 상단 X표시를 클릭하여 종료할 수 있습니다.\n\'계속 학습하기 / 종료\'를 확인한 후 원하는 학습을 진행할 수 있습니다.',
        images: [problemGuide5]
      },
      {
        text: '학습 중간에 문제풀이를 멈추고 목차로 이동 후 다시 학습하려는경우, 학습중을 클릭하여 이동합니다.\n\'이어서 하기 / 처음부터 하기\' 를 확인한 후 원하는 학습을 진행할 수 있습니다.',
        images: [problemGuide6, problemGuide7]
      },
      {
        text: '▶ 학습종료 및 재학습\n문제풀이를 정상적으로 종료시, 성공/실패가 구분되며 풀이한 문제의 점수가 표시됩니다.\n이후 성적표로 이동하여 상세 레포트 확인과 틀린문제를 확인할 수 있습니다.',
        images: [problemGuide8, problemGuide9]
      },
      {
        text: '문제풀이를 완료한 후 다시 학습을 진행하는 경우 학습완료를 클릭하여 이동합니다.\n\'재학습 하기 / 오답학습 / 성적표\'를 확인한 후 원하는 학습을 진행할 수 있습니다.\n오답학습을 이용하는 경우, 힌트 기능을 활용할 수 있습니다.',
        images: [problemGuide10, problemGuide11]
      }
    ]
  },
  {
    id: 4,
    title: '영상강의 이용 안내',
    date: '2025-04-14',
    content: [
      {
        text: '두드림 바둑에서 각 단계를 클릭 후, 오른쪽 버튼 중 강의보기를 클릭하여 이용할 수 있습니다.',
        images: [videoGuide1, videoGuide2]
      },
      {
        text: '▶ 학습 시작\n처음 학습시, 바로 영상을 시청할 수 있는 화면으로 이동합니다.\n재생 실행 버튼을 눌러 영상을 시청할 수 있습니다.',
        images: [videoGuide3]
      },
      {
        text: '▶ 학습중\n강의 중간에 영상시청을 종료하려는 경우, 오른쪽 상단 X표시를 클릭하여 종료할 수 있습니다.\n\'계속 학습하기 / 종료\'를 확인한 후 원하는 학습을 진행할 수 있습니다.',
        images: [videoGuide4]
      },
      {
        text: '강의 중간에 영상시청을 멈추고 목차로 이동 후 다시 학습하려는 경우, 학습중을 클릭하여 이동합니다.\n\'이어서 하기 / 처음부터 하기\' 를 확인한 후 원하는 학습을 진행할 수 있습니다.',
        images: [videoGuide5, videoGuide6]
      },
      {
        text: '▶ 학습종료 및 재학습\n강의보기가 정상적으로 종료시, 학습목차로 이동하거나 문제풀이를 진행할 수 있습니다.\n\'학습완료 / 연습문제\'를 확인한 후 원하는 학습을 진행할 수 있습니다.',
        images: [videoGuide7]
      },
      {
        text: '강의를 완료한 후 다시 학습을 진행하는 경우 학습완료를 클릭하여 이동합니다.\n\'재학습 하기\'를 클릭하여 영상 시청을 다시 진행 할 수 있습니다.',
        images: [videoGuide8, videoGuide9]
      }
    ]
  },
  {
    id: 3,
    title: '두고팡 컨텐츠 안내',
    date: '2025-04-14',
    content: [
      {
        text: '홈화면 학습컨텐츠 탭에서 두고팡을 클릭하면 이용할수 있는 컨텐츠입니다.\n두드림 바둑, 유아 바둑, 바둑 놀이터의 컨텐츠가 있습니다.\n(*25년 4월 기준, 현재는 두드림 바둑만 이용가능하고 그 외 컨텐츠는 추후 순차적으로 업데이트 예정입니다.)',
        images: [dogopangImage1]
      },
      {
        text: '1. 두드림 바둑에서는 단계별 바둑학습서인 두드림을 연계한 단계별 바둑 학습을 할 수 있습니다.\n2. 유아 바둑에서는 유아를 대상으로 하는 바둑학습을 제공합니다.\n3. 바둑 놀이터에서는 다양한 바둑학습 컨텐츠를 여러 형태의 놀이처럼 제공합니다.',
        images: [dogopangImage2]
      }
    ]
  },
  {
    id: 2,
    title: '홈화면 안내',
    date: '2025-04-14',
    content: '로그인 후 처음 나타나는 홈화면입니다.\n홈화면에서는 학생정보, 학습컨텐츠, 최근학습내역, 빠른메뉴 등을 확인할 수 있습니다.\n\n 1. 학생 정보에서는 학습자명 등의 정보를 확인해볼 수 있습니다.\n2. 학습 컨텐츠에서는 두고팡 진텐츠와 두고팡플러스 컨텐츠로 이동할 수 있습니다.\n3. 최근 학습내역에서는 두고팡과 두고팡플러스의 각 컨텐츠별로 최근에 학습한 내역을 확인할 수 있습니다.\n4. 빠른메뉴에서는 학습스케줄, 학습리포트, 공지사항, 리더보드, 학습설정, 사용설명서 등의 내용을 확인할 수 있습니다.',
    image: homeImage
  },
  {
    id: 1,
    title: '로그인 안내',
    date: '2025-04-14',
    content: 'PC 이용시, 두고팡 홈페이지 내 학습모드로 로그인 화면에 접속합니다. \n\n모바일 이용시, 앱을 클릭하여 로그인 화면에 접속합니다.\n\n로그인 화면이 나타나면 아이디 입력란에 아이디를 입력해주시고, 비밀번호 입력란에 비밀번호를 입력 후 로그인 버튼을 클릭해주시면 됩니다.\n\n로그인이 정상적으로 이뤄지면 학습자명이 나타나고, 홈화면으로 이동후 학습을 진행하시면 됩니다.',
    image: guideImage
  }
];

const Guide = () => {
  const [searchParams] = useSearchParams();
  const [activeGuides, setActiveGuides] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [selectedImage, setSelectedImage] = useState(null);
  const itemsPerPage = 5;

  // URL 파라미터에서 guide 값을 받아서 해당 가이드를 자동으로 펼치기
  useEffect(() => {
    const guideId = searchParams.get('guide');
    if (guideId) {
      const id = parseInt(guideId);
      setActiveGuides([id]);
      
      // 해당 가이드가 있는 페이지로 이동
      const guideIndex = guides.findIndex(guide => guide.id === id);
      if (guideIndex !== -1) {
        const pageNumber = Math.floor(guideIndex / itemsPerPage) + 1;
        setCurrentPage(pageNumber);
      }
      
      // 스크롤을 최상단으로 이동
      window.scrollTo(0, 0);
    }
  }, [searchParams]);

  const handleGuideClick = (id) => {
    setActiveGuides((prevActiveGuides) =>
      prevActiveGuides.includes(id)
        ? prevActiveGuides.filter((guideId) => guideId !== id)
        : [...prevActiveGuides, id]
    );
  };

  const handleImageClick = (image, e) => {
    e.stopPropagation(); // 이벤트 버블링 방지
    setSelectedImage(image);
  };

  const closeModal = () => {
    setSelectedImage(null);
  };

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentGuides = guides.slice(indexOfFirstItem, indexOfLastItem);

  const totalPages = Math.ceil(guides.length / itemsPerPage);

  const handlePageClick = (pageNumber) => {
    if (pageNumber === 'prev') {
      setCurrentPage((prevPage) => Math.max(1, prevPage - 1));
    } else if (pageNumber === 'next') {
      setCurrentPage((prevPage) => Math.min(totalPages, prevPage + 1));
    } else {
      setCurrentPage(pageNumber);
    }
  };

  return (
    <div className="max-w-[380px] md:max-w-[800px] mx-auto md:mx-auto mt-12 space-y-6">
      {currentGuides.map((guide, index) => (
        <div key={guide.id} className="border-b pb-4">
          <h3
            className={`text-sm md:text-xl font-bold cursor-pointer flex justify-between pb-3 ${
              activeGuides.includes(guide.id) ? 'text-yellow-600' : 'text-[#333]'
            }`}
            onClick={() => handleGuideClick(guide.id)}
          >
            <span className="mr-4 md:mr-20 tracking-[-0.1em] md:tracking-normal">{`No.${guides.length - indexOfFirstItem - currentGuides.indexOf(guide)}`}</span>
            <span className="flex-1">{guide.title}</span>
            <span className="tracking-[-0.1em] md:tracking-normal text-gray-600">{guide.date}</span>
          </h3>
          <div
            className={`overflow-hidden transition-all duration-500 ease-in-out ${
              activeGuides.includes(guide.id) ? 'max-h-[7000px] opacity-100' : 'max-h-0 opacity-0'
            }`}
          >
            {guide.image && (
              <img 
                src={guide.image} 
                alt={`${guide.title} 이미지`}
                className="w-full h-auto rounded-lg shadow-md mb-4 cursor-pointer hover:opacity-90 transition-opacity"
                onClick={(e) => handleImageClick(guide.image, e)}
              />
            )}
            {Array.isArray(guide.content) ? (
              <div className="space-y-4">
                {guide.content.map((section, index) => (
                  <div key={index} className="space-y-4">
                    {section.images && (
                      <div className="grid grid-cols-1 gap-4">
                        {section.images.map((image, imageIndex) => (
                          <img 
                            key={imageIndex}
                            src={image} 
                            alt={`${guide.title} 이미지 ${index + 1}-${imageIndex + 1}`}
                            className="w-full h-auto rounded-lg shadow-md cursor-pointer hover:opacity-90 transition-opacity"
                            onClick={(e) => handleImageClick(image, e)}
                          />
                        ))}
                      </div>
                    )}
                    <p className="text-xs md:text-base text-gray-600 whitespace-pre-line">
                      {section.text}
                    </p>
                  </div>
                ))}
              </div>
            ) : (
              <p className="text-xs md:text-base text-gray-600 whitespace-pre-line">
                {guide.content}
              </p>
            )}
          </div>
        </div>
      ))}
      
      {/* Pagination */}
      <div className="flex justify-center mt-4 space-x-2">
        {/* Previous page button */}
        <button
            className="px-3 py-1 rounded bg-gray-200 text-gray-600"
            onClick={() => handlePageClick('prev')}
            disabled={currentPage === 1}
        >
            {'<'}
        </button>

        {/* Page number buttons */}
        {[...Array(totalPages)].map((_, index) => (
            <button
            key={index + 1}
            className={`px-3 py-1 rounded ${
                currentPage === index + 1 ? 'bg-yellow-500 text-white' : 'bg-gray-200 text-gray-600'
            }`}
            onClick={() => handlePageClick(index + 1)}
            >
            {index + 1}
            </button>
        ))}

        {/* Next page button */}
        <button
            className="px-3 py-1 rounded bg-gray-200 text-gray-600"
            onClick={() => handlePageClick('next')}
            disabled={currentPage === totalPages}
        >
            {'>'}
        </button>
      </div>

      {/* Image Modal */}
      {selectedImage && (
        <div 
          className="fixed inset-0 bg-black bg-opacity-80 flex items-center justify-center z-50 p-4"
          onClick={closeModal}
        >
          <div className="relative max-w-4xl max-h-[90vh] w-full">
            <button 
              className="absolute top-4 right-4 text-white text-2xl hover:text-gray-300 z-10 bg-black bg-opacity-50 w-8 h-8 flex items-center justify-center rounded-full border-2 border-white shadow-lg"
              onClick={closeModal}
            >
              ✕
            </button>
            <img 
              src={selectedImage} 
              alt="확대된 이미지" 
              className="w-full h-auto object-contain max-h-[90vh]"
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default Guide;
